
__webpack_require__.remotesLoadingData = { chunkMapping: {"8641":["37423"],"7981":["37423"]}, moduleIdToRemoteDataMapping: {"37423":{"shareScope":"default","name":"./GenericOwnerAssignmentDialog","externalModuleId":76318,"remoteName":"grocery"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
